module.exports = __webpack_public_path__ + "static/media/back3.47f44334.png";